module.exports = __webpack_public_path__ + "img/avatar_calculator.4186f4ef.png";